import type {SchemaModifier} from 'schemaDefinition/types';
import type {Agent} from 'services/agent/types';

export const getAgentSchemaModifiers = (
  agent: Agent | undefined,
): SchemaModifier[] => {
  const modifiers: SchemaModifier[] = [];
  if (!agent) {
    return modifiers;
  }

  return modifiers;
};
